import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Header from "../components/Header";
import { Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { BASE_URL2, AuthToken2 } from "../api/base";
import "./Courses.css";

const Courses = () => {
    const [courses, setCourses] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);

    const navigate = useNavigate();

    // 🔹 Fetch Courses (paginated)
    const fetchCourses = async (pageValue = page, sizeValue = sizePerPage) => {
        setLoading(true);
        try {
            const affiliateid = localStorage.getItem("ClassAffiliateID");

            const res = await fetch(`${BASE_URL2}/affiliate-assigned-courses`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "API_Key": AuthToken2,
                },
                body: JSON.stringify({
                    affiliateid,
                    page: pageValue,
                    limit: sizeValue,
                }),
            });

            const data = await res.json();
            setCourses(data?.data?.affiliateAssignedCourses || []);
            setTotalRecords(data?.data?.count || data?.data?.affiliateAssignedCourses?.length || 0);
        } catch (err) {
            console.error("Error fetching courses:", err);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchCourses(1, sizePerPage);
    }, []);

    // 🔹 Filter by search
    const filteredCourses = courses.filter((c) =>
        c.Courses.CourseTitle.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const columns = [
        {
            dataField: "index",
            text: "Srno",
            formatter: (cell, row, rowIndex) => rowIndex + 1 + (page - 1) * sizePerPage,
            headerStyle: { width: "60px", textAlign: "center" },
            style: { textAlign: "center" },
        },
        {
            dataField: "CourseTitle",
            text: "Course Title",
            formatter: (cell, row) => row.Courses.CourseTitle,
            sort: true,
            headerStyle: { width: "550px" },
            style: { whiteSpace: "normal", wordWrap: "break-word" },
        },
        {
            dataField: "TargetYear",
            text: "Target Year",
            formatter: (cell, row) => row.Courses.TargetYear,
            sort: true,
            style: { textAlign:"center" },
        },
        {
            dataField: "StartDate",
            text: "Start Date",
            formatter: (cell, row) =>
                new Date(row.Courses.StartDate).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                }),
            sort: true,
        },
        {
            dataField: "EndDate",
            text: "End Date",
            formatter: (cell, row) =>
                new Date(row.Courses.EndDate).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                }),
            sort: true,
        },
        {
            dataField: "Actions",
            text: "Actions",
            formatter: (cell, row) => (
                <span
                    className="view-link"
                    onClick={() => navigate(`/lectures/${row.Courses.CourseID}/${row.Courses.CourseTitle}`)}
                >
                    View Details
                </span>
            ),
            headerStyle: { padding: "0.5rem 1.6rem" },
            style: { padding: "18px 18px" } // spaces ✅

        },
    ];

    return (
        <div>
            <Header />
            <div className="container courses-container">
                <h2 className="mb-2">My Courses</h2>
                <span style={{ color: "#8094ae", fontSize: "17px" }}>Welcome to My Courses.</span>

                {/* Search */}
                <div className="d-flex mb-3 mt-3">
                    <Form.Control
                        type="text"
                        placeholder="Search by title..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="me-2 search-bar"
                    />
                    <Button variant="primary" onClick={() => fetchCourses(1, sizePerPage)}>
                        Search
                    </Button>
                </div>

                {/* Table */}
                <div className="position-relative">
                    {loading && (
                        <div className="loading-overlay">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}
                    <div className="table-responsive">
                        <BootstrapTable
                            keyField="CourseID"
                            data={filteredCourses}
                            columns={columns}
                            bordered={false}
                            hover
                            condensed
                        />
                    </div>
                </div>

                {/* Custom Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                    {/* Left: Rows per page */}
                    <div className="d-flex align-items-center">
                        <span className="me-2 text-muted">Rows per page:</span>
                        <Form.Select
                            size="sm"
                            style={{ width: "80px" }}
                            value={sizePerPage}
                            onChange={(e) => {
                                const newSize = parseInt(e.target.value);
                                setSizePerPage(newSize);
                                setPage(1);
                                fetchCourses(1, newSize);
                            }}
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                        </Form.Select>
                    </div>

                    {/* Right: Pagination */}
                    <nav className="mt-2 mt-md-0">
                        <ul className="pagination mb-0">
                            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                                <span
                                    className="page-link"
                                    style={{ cursor: page > 1 ? "pointer" : "default" }}
                                    onClick={() => {
                                        if (page > 1) {
                                            setPage(page - 1);
                                            fetchCourses(page - 1, sizePerPage);
                                        }
                                    }}
                                >
                                    &laquo;
                                </span>
                            </li>

                            {Array.from(
                                { length: Math.ceil(totalRecords / sizePerPage) },
                                (_, i) => i + 1
                            ).map((num) => (
                                <li
                                    key={num}
                                    className={`page-item ${num === page ? "active" : ""}`}
                                    style={{ cursor: "pointer" }}
                                >
                                    <span
                                        className="page-link"
                                        onClick={() => {
                                            if (num !== page) {
                                                setPage(num);
                                                fetchCourses(num, sizePerPage);
                                            }
                                        }}
                                    >
                                        {num}
                                    </span>
                                </li>
                            ))}

                            <li
                                className={`page-item ${page >= Math.ceil(totalRecords / sizePerPage) ? "disabled" : ""
                                    }`}
                            >
                                <span
                                    className="page-link"
                                    style={{
                                        cursor:
                                            page < Math.ceil(totalRecords / sizePerPage)
                                                ? "pointer"
                                                : "default",
                                    }}
                                    onClick={() => {
                                        if (page < Math.ceil(totalRecords / sizePerPage)) {
                                            setPage(page + 1);
                                            fetchCourses(page + 1, sizePerPage);
                                        }
                                    }}
                                >
                                    &raquo;
                                </span>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default Courses;
